import React from 'react';
import LanguageSelect from "@/components/UI/Form/Selects/LanguageSelect/LanguageSelect";
import {useLocale} from "next-intl";
import {usePathname, useRouter} from "@/helpers/navigation";

const LanguageChooser = () => {
    const locale = useLocale()
    const pathname = usePathname()
    const router = useRouter()

    const handleChange = (newLocale) => {
        const hash = window.location.hash || '';
        router.push(`${pathname}${hash}`, { locale: newLocale });
    }

    return (
        <LanguageSelect
            suffixIcon={null}
            selected={locale}
            onChange={handleChange}
        />
    );
};

export default LanguageChooser;